(() => {
  if (customElements.get('wv-product-detail-controller')) return;
  class WvProductDetailController extends HTMLElement {
    connectedCallback() {
      const root = this.closest('[data-wv-pdp]');
      if (!root) return;
      this.abort = new AbortController();
      const { signal } = this.abort;
      const product = root.querySelector('[data-section-type="product"]');
      const form = root.querySelector('.product-single__form');
      const mainButton = form?.querySelector('[data-add-to-cart]');
      const sticky = root.querySelector('[data-wv-sticky]');
      const stickyButton = root.querySelector('[data-wv-sticky-add]');
      const addon = root.querySelector('[data-wv-addon]');
      const variants = JSON.parse(root.querySelector('[data-wv-variant-data]')?.textContent || '[]');
      const money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: root.dataset.currency || 'EUR' });
      const getSelection = () => {
        const id = form?.querySelector('[name="id"]')?.value;
        const variant = variants.find(entry => String(entry.id) === id);
        const quantity = Number(form?.elements.namedItem('quantity')?.value || 1);
        return { id, variant, quantity };
      };
      const setText = (element, value) => { if (element && element.textContent !== value) element.textContent = value; };
      const body = document.querySelector('.wv-pdp-body__content');
      const detailSection = document.querySelector('.wv-pdp-body');
      const detailDialog = detailSection?.querySelector('[data-wv-detail-dialog]');
      detailSection?.addEventListener('click', event => {
        const link = event.target.closest('[data-wv-detail-image]');
        if (link && detailDialog) {
          event.preventDefault();
          this.detailFocus = link;
          const image = document.createElement('img');
          image.src = link.href;
          image.alt = link.querySelector('img')?.alt || '';
          detailDialog.querySelector('[data-wv-detail-zoom-image]').replaceChildren(image);
          detailDialog.showModal();
        }
        if (event.target.closest('[data-wv-detail-close]')) detailDialog?.close();
      }, { signal });
      detailDialog?.addEventListener('close', () => this.detailFocus?.focus(), { signal });
      const highlights = root.querySelector('[data-wv-highlights]');
      const highlightsHeading = [...(body?.querySelectorAll('h2,h3') || [])].find(heading => /^Highlights$/i.test(heading.textContent.trim()));
      if (highlights && highlightsHeading?.nextElementSibling?.tagName === 'UL') {
        const list = highlightsHeading.nextElementSibling.cloneNode(true);
        [...list.children].slice(4).forEach(item => item.remove());
        highlights.replaceChildren(list);
        highlights.hidden = false;
      }
      const sectionLinks = document.querySelector('[data-wv-section-links]');
      if (sectionLinks && !sectionLinks.dataset.ready) {
        sectionLinks.dataset.ready = 'true';
        [...(body?.querySelectorAll('h2') || [])].slice(0, 5).forEach((heading, index) => {
          if (!heading.id) heading.id = `${root.id}-detail-${index}`;
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent;
          sectionLinks.append(link);
        });
      }
      const initialParams = new URLSearchParams(location.search);
      product?.addEventListener('variantChange', () => {
        queueMicrotask(() => {
          const url = new URL(location.href);
          for (const key of ['view', 'pb', 'preview_theme_id']) {
            if (initialParams.has(key)) url.searchParams.set(key, initialParams.get(key));
          }
          history.replaceState(history.state, '', url);
        });
      }, { signal });
      root.querySelectorAll('.product__photo-zoom').forEach(button => button.setAttribute('aria-label', 'Produktbild vergrößern'));
      root.querySelectorAll('.product__thumb-arrow--prev').forEach(button => button.setAttribute('aria-label', 'Vorherige Vorschaubilder'));
      root.querySelectorAll('.product__thumb-arrow--next').forEach(button => button.setAttribute('aria-label', 'Weitere Vorschaubilder'));
      const sync = () => {
        if (!mainButton || !stickyButton) return;
        stickyButton.disabled = this.busy || mainButton.disabled || mainButton.classList.contains('btn--loading');
        stickyButton.textContent = mainButton.textContent.trim();
        root.querySelector('[data-wv-sticky-price]').textContent = root.querySelector('[data-product-price]')?.textContent.trim() || '';
        const selected = form.querySelector('[data-product-select] option:checked');
        const label = root.querySelector('[data-wv-sticky-variant]');
        if (selected && label && !selected.textContent.includes('Default Title')) label.textContent = selected.textContent.split(' - ')[0].trim();
        const { variant, quantity } = getSelection();
        const total = root.querySelector('[data-wv-total]');
        if (total) total.hidden = !addon?.checked;
        root.querySelectorAll('.shopify-payment-button, .shopify-payment-terms').forEach(element => { element.hidden = Boolean(addon?.checked); });
        if (addon?.checked && variant && Number.isInteger(quantity) && quantity > 0) {
          const formatted = money.format((variant.price + Number(addon.dataset.price)) * quantity / 100);
          setText(root.querySelector('[data-wv-total-price]'), formatted);
          setText(root.querySelector('[data-wv-sticky-price]'), formatted);
        }
      };
      this.observer = new MutationObserver(sync);
      if (product) this.observer.observe(product, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class', 'selected'] });
      sync();
      root.addEventListener('change', sync, { signal });
      root.addEventListener('input', sync, { signal });
      form?.addEventListener('submit', async event => {
        if (!addon?.checked) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy) return;
        const errorBox = root.querySelector('[data-wv-addon-error]');
        const { id, variant, quantity } = getSelection();
        if (!variant?.available || !Number.isInteger(quantity) || quantity < 1) {
          setText(errorBox, 'Bitte prüfe die gewählte Ausführung und Menge.');
          return;
        }
        this.busy = true;
        mainButton.disabled = true;
        setText(errorBox, '');
        sync();
        try {
          const base = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${base}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity }, { id: addon.dataset.variantId, quantity }] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Die Auswahl konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
          location.assign(`${base}cart`);
        } catch (error) {
          setText(errorBox, error.message || 'Bitte prüfe Deine Verbindung und versuche es erneut.');
          errorBox?.scrollIntoView({ block: 'center' });
          this.busy = false;
          mainButton.disabled = !getSelection().variant?.available;
          sync();
        }
      }, { capture: true, signal });
      if (mainButton && sticky) {
        this.intersection = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting;
        }, { threshold: 0.1 });
        this.intersection.observe(mainButton);
      }
      root.addEventListener('click', event => {
        const target = event.target.closest('button');
        if (!target) return;
        if (target.hasAttribute('data-wv-sticky-add') && mainButton && !mainButton.disabled) {
          mainButton.click();
          const errors = form.querySelector('.errors');
          if (errors) errors.scrollIntoView({ block: 'center' });
        }
        if (target.dataset.wvOpen) {
          const dialog = document.getElementById(target.dataset.wvOpen);
          if (dialog && root.contains(dialog)) {
            this.returnFocus = target;
            dialog.showModal();
          }
        }
        if (target.hasAttribute('data-wv-close')) target.closest('dialog')?.close();
        if (target.dataset.wvMedia) root.querySelector(`[data-product-thumb][data-id="${target.dataset.wvMedia}"]`)?.click();
        if (target.dataset.wvDirection) {
          const thumbs = [...root.querySelectorAll('[data-product-thumb]')].filter(thumb => thumb.getClientRects().length);
          const active = Math.max(0, thumbs.findIndex(thumb => thumb.classList.contains('is-active')));
          thumbs[(active + Number(target.dataset.wvDirection) + thumbs.length) % thumbs.length]?.click();
        }
      }, { signal });
      root.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }, { signal });
        dialog.addEventListener('close', () => this.returnFocus?.focus(), { signal });
      });
      form?.addEventListener('ajaxProduct:error', () => form.scrollIntoView({ block: 'center' }), { signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.intersection?.disconnect();
    }
  }
  customElements.define('wv-product-detail-controller', WvProductDetailController);
})();
